import restCrudActions from '../../../np-crud/store/restCrudActions';
import config from '../../../../config/config';
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'report-data',
    pluginName: 'SETTINGS',
    entityName: 'REPORT_DATA',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch report data action creators
export const fetchReportDataInit = () => {
    return crudActions.fetchInit();
};
export const fetchReportDataStart = () => {
    return crudActions.fetchStart();
};
export const fetchReportDataSuccess = (fetchReportDataCount, listReportDataCount) => {
    return crudActions.fetchSuccess(fetchReportDataCount, listReportDataCount);
};
export const fetchReportDataFail = () => {
    return crudActions.fetchFail();
};
export const fetchReportDataCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchReportDataStart());
        try {
            let countRes = await rest.post("report-data/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchReportDataSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchReportDataFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch report data."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchReportDataFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch report data."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchReportData = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchReportDataStart());
        try {
            let listRes = await rest.post("report-data/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchReportDataSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchReportDataFail());
            return []

        } catch (error) {
            dispatch(fetchReportDataFail());
            return []
        }
    }
}

export const fetchCustomer = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchReportDataStart());
        try {
            let listRes = await rest.post("customers/load", data);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchReportDataSuccess(data.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchReportDataFail());
            return []

        } catch (error) {
            dispatch(fetchReportDataFail());
            return []
        }
    }
}

// Load report data action creators
export const loadReportDataInit = () => {
    return crudActions.loadInit();
};
export const loadReportDataStart = () => {
    return crudActions.loadStart();
};
export const loadReportDataSuccess = loadedReportData => {
    return crudActions.loadSuccess(loadedReportData);
};
export const loadReportDataFail = error => {
    return crudActions.loadFail(error);
};
export const loadReportData = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};

// Create report data action creators
export const createReportDataInit = () => {
    return crudActions.createInit();
};
export const createReportDataStart = () => {
    return crudActions.createStart();
};
export const createReportDataSuccess = createdReportData => {
    return crudActions.createSuccess(createdReportData);
};
export const createReportDataFail = error => {
    return crudActions.createFail(error);
};
export const createReportData = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createReportDataStart());
        try {
            let res = await rest.post('/report-data/create', params);
            if (res.data && res.data.succeeded) {
                dispatch(createReportDataSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully created report data.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createReportDataFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create report data."}`
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create report data."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createReportDataFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}


// Edit report data action creators
export const editReportDataInit = () => {
    return crudActions.editInit();
};
export const editReportDataStart = () => {
    return crudActions.editStart();
};
export const editReportDataSuccess = editedReportData => {
    return crudActions.editSuccess(editedReportData);
};
export const editReportDataFail = error => {
    return crudActions.editFail(error);
};
export const editReportData = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editReportDataStart());
        try {
            let res = await rest.post('/report-data/save', params);
            if (res.data && res.data.succeeded) {
                dispatch(editReportDataSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated report data.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editReportDataFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit report data."}`
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit report data."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editReportDataFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Bulk delete report data action creators
export const bulkDeleteReportDataInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteReportDataStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteReportDataSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteReportDataFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteReportData = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteReportDataStart());
        try {
            let res = await rest.post('/report-data/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteReportDataSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted report data.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteReportDataFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete report data."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete report data."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteReportDataFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

// custom functions 
export const fetchLogos = (id) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/logos/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const logos = [];
                for (var logo of res.data.result.data) {
                    let relativePath = logo.ImageLocation?.split('/') ?? [];
                    relativePath.shift();
                    logos.push({
                        value: logo.LogoID,
                        displayValue: logo.Name,
                        imageLocation: `${config.backend_domain}:${config.backend_port}/static/${relativePath.join('/')}`
                    });
                }
                return logos;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list logos."}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}